import React from 'react';
import api from "./../../../services/api";
import { NavLink } from 'react-router-dom';
import './../../../pages/Representante_Instituição/Tela_RI_Cadastro/styles.css';
import './../../../pages/Representante_Instituição/Tela_RI_Pacientes_Cadastro/styles.css';
import GetAgent from './GetAgent';
import { user_token } from '../../../services/Auth';
import "./style.css";
import Grid from '@material-ui/core/Grid';
import SideNav from './../../../components/SideNav';
import GetProfessional from './GetProfessional';
import GetUser from './GetUser';
import SwitchButton from './SwitchButton';

var token = localStorage.getItem(user_token);

export default class FormsAgendamento extends React.Component {

    state = {
        exames: [],
    }

    componentDidMount(){
        this.loadData();
    }

    loadData = async () => {
        const { id } = this.props.match.params;
        console.log(id);
        const request = await api.get(`/exam/${id}`, {headers: {'x-access-token': token}});
        console.log(request);
        console.log(request.data);
        this.setState({ exames: request.data });
    
      };

    render() {
        return (
        <>
        <SideNav />
        <div id="top-PS">
        <Grid container spacing={0} direction="row" justify="left"  alignItems="center" style={{ marginTop: '-35vh'}}>
          <Grid item xs={2} sm={2} md={1} lg={1} align="center">     
                <NavLink id="voltar-a" to="/tela_ps_painel"> <button id="voltar">Voltar</button></NavLink>
            </Grid>
            <Grid item xs={8} sm={8} md={10} lg={10}></Grid>   
            <Grid item xs={2} sm={2} md={1} lg={1} align="center"> 
          </Grid>
        </Grid>
        </div>
          <Grid container spacing={0} direction="row" justify="left"  alignItems="center">
          <Grid item xs={12} sm={12} md={10} lg={3} align="center"></Grid>
          <Grid item xs={12} sm={12} md={10} lg={6} align="center">
          <div id="main-RI-Consulta-Pendente">
          <h1 id="title">Consulta Confirmada</h1>
          <br></br>
          <div id="lista-style">
          {this.state.exames.map(details => (
          <> 
            <div id="exam">
              <h3 style={{ textAlign: 'center'}}>Informações da Instituição</h3><br></br>
              <GetAgent agent_id={details.agent_id}/>
              <br></br>
              <h3 style={{ textAlign: 'center'}}>Informações do Profissional de Saúde</h3><br></br>
              <GetProfessional professional_id={details.professional_id}/>
              <br></br>
              <h3 style={{ textAlign: 'center'}}>Informações da Consulta</h3><br></br>
              <p id="RI-Title-Cadastro-Paciente">Finalidade de Atendimento:</p><p>{details.appointment_type}</p>
              <p id="RI-Title-Cadastro-Paciente">Especialidade: </p><p>{details.medical_appointment_type}</p>
              <p id="RI-Title-Cadastro-Paciente">Proposta: </p><p>{details.appointment_purpose}</p>
              <p id="RI-Title-Cadastro-Paciente">Turno de atendimento: </p><p>{details.appointment_period}</p>
              <p id="RI-Title-Cadastro-Paciente">Data/Hora:</p><p>{details.date}</p>
              <p id="RI-Title-Cadastro-Paciente">Obervações:</p><p>{details.notes}</p>
              <br></br>
              <h3 style={{ textAlign: 'center'}}>Informações do Paciente</h3><br></br>
              <GetUser user_id={details.user_id}/>
              <br></br>
              </div>
              <div id="collapsed-PS_Painel">
                <NavLink to="/"><button id="option-PS-Painel">Iniciar chamada por vídeo</button></NavLink>
                <SwitchButton _id={details.user_id}/>
              </div>
              <br></br>
            </>
          ))}
        </div>
        </div>
        </Grid>
        </Grid>
      </>
        );
    }
}
